export const FALLBACK_PRODUCT_LOGO_INCOME_ARP_CODE = '603.003.110';
export const FALLBACK_DONATION_CARD_LOGO_INCOME_ARP_CODE = '603.003.106';

export const normalizeLogoIncomeArpCode = (value) => {
  const trimmed = String(value || '').trim();
  return trimmed || null;
};

export const resolveEffectiveLogoIncomeArpCode = (
  logoIncomeArpCode,
  defaultLogoIncomeArpCode,
  fallback = FALLBACK_PRODUCT_LOGO_INCOME_ARP_CODE,
) =>
  normalizeLogoIncomeArpCode(logoIncomeArpCode)
  || defaultLogoIncomeArpCode
  || fallback;

export const buildDonationCardLogoIncomeHelperText = (defaultLogoIncomeArpCode) =>
  `Boş bırakılırsanız sistem varsayılanı (${defaultLogoIncomeArpCode || FALLBACK_DONATION_CARD_LOGO_INCOME_ARP_CODE}) kullanılır.`;
